import script from "./HomeViewCopy.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeViewCopy.vue?vue&type=script&setup=true&lang=js"

import "./HomeViewCopy.vue?vue&type=style&index=0&id=48d0f238&lang=scss&scoped=true"

import exportComponent from "F:\\工作项目\\慧链平台\\快加易官网\\kjy-door\\fiveg-co-di-vue-kjy-door\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48d0f238"]])

export default __exports__